module.exports = __webpack_public_path__ + "img/arrow.bf6a827b.svg";